<div
  *ngIf="customerType?.name"
  [style.background-color]="backgroundColor"
  [style.color]="textColor"
>
  {{ customerType.name | customerTypeFormatter }}
</div>
